import { useQuery } from '@tanstack/react-query'
import { handleGetRequest } from '../utils/api-handler.util'
import { QueryKeys } from '../utils/queryKeyGenerator'
import USER_TYPE from '../constants/userType'

export function useShopDetails(userType, shopSlug) {

  const queryKey =
    userType === USER_TYPE.retailer
      ? QueryKeys.adminRetailerDetails(shopSlug)
      : QueryKeys.adminWholesellerDetails(shopSlug)

  const path =
    userType === USER_TYPE.retailer
      ? `/admin/retailers/${shopSlug}`
      : `/admin/wholesellers/${shopSlug}`

  const query = useQuery({
    queryKey,
    queryFn: () => handleGetRequest(path),
    enabled: !!shopSlug,
  })

  const invalidate =
    userType === USER_TYPE.retailer
      ? QueryKeys.adminRetailerDetails.invalidate
      : QueryKeys.adminWholesellerDetails.invalidate


  return {
    shop: query.data?.data || {},
    documents: query.data?.documents || [],
    invalidate: () => invalidate(shopSlug),
    ...query,
  }
}
